import './BrasilPapayaSection.css';

const BrasilPapayaSection = () => {
    return (
        <section className="brasil-papaya">
            <div className="banda">
                <div className="image-container">
                    <img src="news-4.jpg" alt="Brasil Papaya" className="background-image" />
                </div>
                <div className="text-container">
                    <img src="lettering.png" alt="Logo" className="logo" />
                    <p className="quote">
                        <em>“Rockin' Since 1993”</em>
                    </p>
                    <div className="content-banda">
                        <div className="left-column">
                            <p className="details">
                                Brasil Papaya nasceu com a missão de derrubar o estigma de que música instrumental é elitista e inacessível. Desde os primeiros ensaios em Laguna, SC o Brasil Papaya vem rompendo barreiras, misturando gêneros como choro, blues e flamenco, sempre mantendo uma pegada autêntica de rock and roll. Esse estilo inovador chamou a atenção de músicos e marcas nacionais, levando a banda para além do underground e consolidando seu lugar na cena musical. Ao longo dos anos, músicos talentosos passaram pelo Brasil Papaya, contribuindo significativamente para sua trajetória e evolução.
                            </p>
                            <p className="details">
                                Desde 2019, a Brasil Papaya segue com os guitarristas fundadores Renato e Dudu Pimentel, que exploram com naturalidade estilos como jazz, flamenco, rock e música nativista. Ao lado deles estão Baba Jr no baixo e Ginho Bernardes na bateria, músicos experientes com ampla atuação em projetos nacionais. Essa formação aprofunda a sonoridade da banda e reforça sua proposta de tornar a música instrumental brasileira cada vez mais acessível, envolvente e cheia de personalidade.
                            </p>
                            <p className="details">

                            </p>
                            <p className="details">

                            </p>
                            <p className="details">

                            </p>
                        </div>
                        <div className="right-column">
                            <p className="details">
                                A participação do Brasil Papaya em festivais catarinenses e turnês foi ampliada por colaborações com a Camerata Florianópolis, resultando nos espetáculos “Clássicos com Energia” , “Rock n’ Camerata” e “Tributo ao Queen". A parceria alcançou seu ápice no Rock in Rio de 2015, onde a banda dividiu o palco com a Camerata e Steve Vai para uma plateia de 90 mil pessoas, marcando seu lugar na música instrumental brasileira.
                            </p>
                            <p className="details">
                                Comemorando 30 anos de estrada, o Brasil Papaya lança sua série de novidades, incluindo a gravação de um show especial com a Camerata de Santa Catarina, uma turnê por Santa Catarina, um aplicativo musical para promover o estudo instrumental e um documentário que celebra a trajetória única da banda.
                            </p>
                            <p className="details">
                                Ao longo dos anos, o Brasil Papaya tem provado que a música instrumental pode ser acessível, envolvente e apaixonante, conectando-se com públicos de todas as idades e lugares.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BrasilPapayaSection;
